import type { ArabicCatalog } from "@ncp/i18n";
import type en from "./stepLetters.en";

/** الخطابات التي ترسلها خطوة الموظف، معروضة كاملة في تأكيد الخطوة قبل اتخاذها: طلب الاستيفاء، وطلب المستندات المؤجلة عند التقديم، والإخطار بالرفض الضمني للتظلم، والإخطار بتمديد مدة الدراسة. */
const ar: ArabicCatalog<typeof en> = {
  title_zero: "لا ترسل هذه الخطوة أي خطاب",
  title_one: "الخطاب الذي ترسله هذه الخطوة",
  title_two: "الخطابان اللذان ترسلهما هذه الخطوة",
  title_few: "الخطابات التي ترسلها هذه الخطوة ({{count}})",
  title_many: "الخطابات التي ترسلها هذه الخطوة ({{count}})",
  title_other: "الخطابات التي ترسلها هذه الخطوة ({{count}})",
  hint: "معبأة من بيانات الملف كما سترسلها الخطوة، وترسل باسمكم عند تأكيد الخطوة.",
  loading: "جار التحقق من الخطابات التي ترسلها هذه الخطوة…",
  updating: "جار تحديث الخطابات وفق آخر صياغة…",
  failed: "تعذر عرض الخطابات التي ترسلها هذه الخطوة",
  to: "إلى {{name}}",
  legalEffect: "ذو أثر قانوني",
  legalEffectHint: "يرسل عند تأكيدكم الخطوة بصفتكم موظفا مخولا (الشرطان 3.1 و3.2).",
  courtesy: "خطاب إعلامي",
  reply: "الرد خلال {{period}}",
  english: "الإنجليزية",
  arabic: "العربية",
  sources: {
    "completion-request": "طلب الاستيفاء",
    "documents-to-follow": "طلب المستندات المؤجلة عند التقديم",
    "implicit-rejection": "إخطار بالرفض الضمني",
    "review-extended": "إخطار بتمديد المدة القانونية لدراسة الطلب",
  },
  dialog: {
    title: "تأكيد الخطوة",
    description: "ترسل هذه الخطوة الخطابات المعروضة أدناه باسمكم، كما هي، عند التأكيد.",
    confirm: "تأكيد الخطوة",
  },
};

export default ar;
